/* eslint-disable no-unused-vars */

import React, { Component } from 'react';
import { connect } from 'react-redux';

// components
import RadioGroup, { Radio } from '../../../../components/RadioGroup';
import LoadingIndicator from '../../../../components/LoadingIndicator';
import AlertMessage from '../../../../components/AlertMessage';

// redux
import { fetchCompanies } from '../../../../redux/admin-companies';
import { getCompaniesUI } from '../../../../redux/selectors';
import { logout, setActiveCompany } from '../../../../redux/auth';

// util
import {
  LOCAL_STORAGE_USER_NAME,
  saveCustomerServiceCompany,
} from '../../../../shared/http/auth';

// css
import './styles.css';

import {
  Action,
  AvatarContainer,
  ButtonContainer,
  CarbonContentContainer,
  ChangeClientText,
  DivideLine,
  ExitPlatformText,
  FirstText,
  IconContainer,
  Item,
  PlatformActionsContainer,
  Popover,
  PopoverContainer,
  SecondText,
  SelectCompanyModalHeader,
  StyledButton,
  StyledChangeCircleOutlined,
  StyledExitToApp,
  StyledModal,
  TextFieldStyled,
  UserContainer,
} from './styles';
import { filtersClear } from '../../../../redux/tracking';
import AvatarIcon from '../../../../assets/images/Avatar.png';

class SelectCompanyModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCompany: '',
      searchFilter: '',
    };
  }

  componentDidMount() {
    this._fetchCompanies();
  }

  _fetchCompanies = () => {
    const { dispatch, divisions } = this.props;
    dispatch(fetchCompanies(null, divisions));
  };

  _changeCompany = newCompany => {
    const { dispatch, onCompanySelect, companies } = this.props;

    dispatch(filtersClear());

    // mark checkbox
    this.setState({
      activeCompany: newCompany,
    });

    // get company name
    const filteredCompanyArray = companies.filter(
      company => company.id === newCompany,
    );

    const newCompanyName = filteredCompanyArray[0].corporateName;

    //mock
    const companyCarbonEmission = filteredCompanyArray[0].carbonEmission;
    const companyCarbonCredit = filteredCompanyArray[0].carbonCredit;
    const companyRegistration = filteredCompanyArray[0].registration;
    const companyDescription = filteredCompanyArray[0].description;
    const companyCertificateUrl = filteredCompanyArray[0].certificateUrl;

    const companyData = {
      carbonEmission: companyCarbonEmission,
      carbonCredit: companyCarbonCredit,
      registration: companyRegistration,
      description: companyDescription,
      certificateUrl: companyCertificateUrl,
    };

    const companyDivisions = filteredCompanyArray[0].divisions.replaceAll(' ', '');
    
    // add to store
    dispatch(setActiveCompany(newCompany, newCompanyName, companyData, companyDivisions));

    // add to localstorage
    saveCustomerServiceCompany(newCompany, newCompanyName, companyData, companyDivisions);

    // redirect
    onCompanySelect();
  };

  _updateSearchFilter = event => {
    this.setState({
      searchFilter: event.target.value,
    });
  };

  _getFilteredCompanyList = () => {
    const { searchFilter } = this.state;
    const { companies } = this.props;

    // Empty search filter
    if (searchFilter === '') {
      return companies.map(company => ({
        value: company.id,
        label: company.corporateName,
      }));
    }

    // Search filter has value
    const pattern = new RegExp(searchFilter, 'i');
    return companies
      .map(company => ({ value: company.id, label: company.corporateName }))
      .filter(company => pattern.test(company.label));
  };

  _renderHeader = () => (
    <SelectCompanyModalHeader>
      <TextFieldStyled
        label="Digite o nome do cliente para filtrar"
        placeholder="Digite o nome do cliente para filtrar"
        fullWidth
        name="searchFilter"
        className="SelectCompanyModal__filter-input"
        onChange={this._updateSearchFilter}
      />
      <DivideLine />
    </SelectCompanyModalHeader>
  );

  _renderSecondHeader = () => {
    const userName = window.localStorage.getItem(LOCAL_STORAGE_USER_NAME) ?? '';

    return (
      <PopoverContainer>
        <Popover>
          <AvatarContainer>
            <img src={AvatarIcon} width={40} height={40} alt="Avatar" />
          </AvatarContainer>
          <UserContainer>
            <FirstText>{this.props.currentCompanyName}</FirstText>
            <SecondText>{userName}</SecondText>
          </UserContainer>
        </Popover>
      </PopoverContainer>
    );
  };

  _logout = () => {
    const { dispatch, history } = this.props;

    dispatch(logout());
    dispatch(filtersClear());
    history.push('/');
  };

  render() {
    const {
      ui,
      onToggleCompanySelectModal,
      removeCloseModal = false,
      onToggleSelectCompanyModalList,
      selectCompanyModalListIsVisible,
      //onToggleShowCertificateModal,
      onToggleShowCarbonCreditModal,
      showPopover,
      companyData,
    } = this.props;

    let parsedCompanyData = {};

    try {
      parsedCompanyData = JSON.parse(companyData);
    } catch {
      parsedCompanyData = {
        carbonEmission: null,
        carbonCredit: null,
        registration: null,
        description: null,
        certificateUrl: null,
      };
    }

    const {
      carbonEmission,
      carbonCredit,
      registration,
      description,
      certificateUrl,
    } = parsedCompanyData;

    const disableCertificateButton =
      !registration || !description || !certificateUrl;

    const formatCarbonEmission = carbonEmission;

    if (!selectCompanyModalListIsVisible && showPopover) {
      return (
        <StyledModal
          size="small"
          renderHeader={this._renderSecondHeader()}
          onBackdropClick={!removeCloseModal && onToggleCompanySelectModal}
          hasClose={!removeCloseModal}
          removeHeader
        >
          {carbonEmission > 0 && (
            <CarbonContentContainer>
              <Item>
                <FirstText>Emissão de Carbono</FirstText>
                <SecondText>
                  {formatCarbonEmission.toFixed(3)} T. CO2 EQ.
                </SecondText>
              </Item>
              {carbonCredit > 0 && (
                <Item>
                  <FirstText>Crédito de carbono</FirstText>
                  <SecondText>{carbonCredit} RCE</SecondText>
                </Item>
              )}
              <ButtonContainer>
                {/* <StyledButton
                  type="button"
                  skin="primary"
                  onClick={() =>
                    onToggleShowCertificateModal(disableCertificateButton)
                  }
                >
                  Meu Certificado de Neutralização
                </StyledButton> */}
                <StyledButton
                  type="button"
                  className="Button__outline"
                  onClick={onToggleShowCarbonCreditModal}
                >
                  Utilizar meu crédito de carbono
                </StyledButton>
              </ButtonContainer>
            </CarbonContentContainer>
          )}

          <PlatformActionsContainer>
            <Action onClick={onToggleSelectCompanyModalList}>
              <IconContainer>
                <StyledChangeCircleOutlined />
              </IconContainer>
              <ChangeClientText>Trocar cliente</ChangeClientText>
            </Action>
            <Action onClick={this._logout}>
              <IconContainer>
                <StyledExitToApp />
              </IconContainer>
              <ExitPlatformText>Sair da plataforma</ExitPlatformText>
            </Action>
          </PlatformActionsContainer>
        </StyledModal>
      );
    }

    return (
      <div>
        <StyledModal
          title="Selecionar o cliente para visualização"
          size="small"
          renderHeader={this._renderHeader()}
          onBackdropClick={!removeCloseModal && onToggleSelectCompanyModalList}
          hasClose={!removeCloseModal}
        >
          {ui.isFetching && (
            <LoadingIndicator theme="dark" text="Carregando..." />
          )}

          {ui.error && (
            <AlertMessage
              message={`Ocorreu um erro ao carregar a lista de empresas: ${ui.error}`}
              error
              box
              actionText="Tentar Novamente"
              onRetry={this._fetchCompanies}
              className="SelectCompanyModal__error-message"
            />
          )}
          {!ui.isFetching && (
            <div>
              <RadioGroup
                value={this.state.activeCompany}
                onChangeValue={this._changeCompany}
              >
                {this._getFilteredCompanyList().map(company => (
                  <Radio
                    key={company.value}
                    value={company.value}
                    label={company.label}
                    upperCaseText
                  />
                ))}
              </RadioGroup>
            </div>
          )}
        </StyledModal>
      </div>
    );
  }
}

SelectCompanyModal.propTypes = {};
SelectCompanyModal.defaultProps = {};

function mapStateToProps(state) {
  return {
    ui: getCompaniesUI(state),
    companies: state.adminCompanies.companies.data,
    divisions: state.auth.divisions,
    currentCompanyName: state.auth.activeCompanyName,
    companyData: state.auth.companyData,
  };
}

export default connect(mapStateToProps)(SelectCompanyModal);
